import { Button } from '@cian/ui-kit';
import { IconFilePrint16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from 'shared/actions/authentication';
import { selectIsAuthenticated } from 'shared/selectors';

import { trackClick } from './tracking';
import { toggle } from '../../store/popups/print';

export function PrintButtonNewContainer() {
  const isUserAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();

  const clickButtonHandle = () => {
    dispatch(toggle(true));
    trackClick();
  };

  const handelUserAuth = () => {
    if (!isUserAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => () => clickButtonHandle(),
        }),
      );
    } else {
      clickButtonHandle();
    }
  };

  return (
    <Button
      theme="stroke_secondary"
      beforeIcon={<IconFilePrint16 color="icon-secondary-default" />}
      onClick={handelUserAuth}
      size="XS"
      title="Печать"
    />
  );
}
